import { render, staticRenderFns } from "./PageContainer.vue?vue&type=template&id=2854b104&scoped=true"
import script from "./PageContainer.vue?vue&type=script&lang=js"
export * from "./PageContainer.vue?vue&type=script&lang=js"
import style0 from "./PageContainer.vue?vue&type=style&index=0&id=2854b104&prod&lang=scss&scoped=true"
import style1 from "./PageContainer.vue?vue&type=style&index=1&id=2854b104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2854b104",
  null
  
)

export default component.exports